import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_production/697c564d921dc90014549022/cyprus_diving/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/697c564d921dc90014549022/cyprus_diving/src/app/marine-life/components/MarineLifeInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/697c564d921dc90014549022/cyprus_diving/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/697c564d921dc90014549022/cyprus_diving/src/components/ui/AppIcon.tsx");
